export default "__VITE_ASSET__EkXvwgL7__"